// DEPANN7 logo — the client's exact artwork (unmodified, only margins trimmed).
// tone="dark"  -> anthracite wordmark on light backgrounds (on-white file)
// tone="light" -> white wordmark on dark backgrounds (on-black file; blended so
//                 the black canvas disappears over dark surfaces)
import onWhite from "@/assets/depann7-onwhite.jpeg";
import onBlack from "@/assets/depann7-onblack.jpeg";

export default function Logo({ tone = "dark", className = "" }) {
  const light = tone === "light";
  return (
    <img
      src={light ? onBlack : onWhite}
      alt="Depann7 — Dépannage · Remorquage · Assistance"
      draggable="false"
      className={`w-auto select-none ${light ? "mix-blend-lighten" : ""} ${className}`}
    />
  );
}

// Kept for compatibility: same exact wordmark, used where a compact logo is needed.
export function LogoMark({ tone = "dark", className = "" }) {
  return <Logo tone={tone} className={className} />;
}
